import { PLATE_UPLOADED_NAMESPACE } from 'src/constants/forms';

export default class PlateTemplate {
  static NAME = PLATE_UPLOADED_NAMESPACE;

  static getCreateConfig() {
    return {
      url: '/v2/oligos/plates/upload',
      stringify: false,
    };
  }

  constructor(template = {}) {
    this.totalPlates = template.platesCount;
    this.totalOligos = template.oligosCount;
    this.totalBases = template.basesCount;
    this.plateSize = template.plateSize;
    this.shippingDays = template.shippingDays;
  }
}
